import axios from '@/plugins/axios'
import { errorResponse, successResponse } from '@/plugins/axios/utils'

const serverURL = process.env.BACKEND_URL

const baseURL = `${serverURL}/v2/buildings`

export function getBuildingInfo (id) {
  return axios.get(`${baseURL}/openLink/${id}`)
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}

export function getTripodLogo (buildingId) {
  return axios.get(`${baseURL}/tripodLogo/${buildingId}`)
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}
